import OperatorStatusChangedInAnotherApp
    from "~/operatorApplication/ts/service/comet/listeners/OperatorStatusChangedInAnotherApp";
import OperatorCometListener from "~/operatorApplication/ts/service/comet/OperatorCometListener";
import AddClientToBuddyList from "~/operatorApplication/ts/service/comet/listeners/AddClientToBuddyList";
import RemoveClientFromBuddyList from "~/operatorApplication/ts/service/comet/listeners/RemoveClientFromBuddyList";
import UpdateClient from "~/operatorApplication/ts/service/comet/listeners/UpdateClient";
import UpdateUnreadedMessageIdList from "~/operatorApplication/ts/service/comet/listeners/UpdateUnreadedMessageIdList";
import UpdateParams from "~/operatorApplication/ts/service/comet/listeners/UpdateParams";
import {OPERATOR_APPLICATION_RELOAD_DATA_EVENT} from "~/operatorApplication/ts/service/comet/Constants";
import OperatorsOnlineUpdatedListener from "~/operatorApplication/ts/service/comet/listeners/OperatorsOnlineUpdated";
import NewMessage from "~/operatorApplication/ts/service/comet/listeners/NewMessage";
import Ping from "~/operatorApplication/ts/service/comet/listeners/Ping";
import MessageTemplatesUpdated from "~/operatorApplication/ts/service/comet/listeners/MessageTemplatesUpdated";
import ChangeMessageStatus from "~/operatorApplication/ts/service/comet/listeners/ChangeMessageStatus";
import {
    OPERATOR_LOGGED_OUT,
    OperatorApplicationEventManager
} from "~/operatorApplication/ts/OperatorApplicationEventManager";
import Delay from "~/ts/library/Delay";
import Listener from "~/ts/library/listen/Listener";
import EditMessage from "~/operatorApplication/ts/service/comet/listeners/EditMessage";
import DeleteMessage from "~/operatorApplication/ts/service/comet/listeners/DeleteMessage";
import SnippetListener from "~/operatorApplication/ts/service/comet/listeners/SnippetListener";
import Typing from "~/operatorApplication/ts/service/comet/listeners/Typing";
import OperatorTyping from "~/operatorApplication/ts/service/comet/listeners/OperatorTyping";
import ClientClickOnLink from "~/operatorApplication/ts/service/comet/listeners/ClientClickOnLink";
import NewTargetClient from "~/operatorApplication/ts/service/comet/listeners/NewTargetClient";
import {OperatorAccountStore} from "~/operatorApplication/ts/store/OperatorAccountStore";
import CheckToken from "~/operatorApplication/ts/service/comet/listeners/CheckToken";
import CometTimestampMismatchPayloadInterface from "~/ts/library/listen/CometTimestampMismatchPayloadInterface";
import UpdateOperatorDialogCount from "~/operatorApplication/ts/service/comet/listeners/UpdateOperatorDialogCount";
import MessageDialogUpdated from "~/operatorApplication/ts/service/comet/listeners/MessageDialogUpdated";
import CopilotCommandResponse from "~/operatorApplication/ts/service/comet/listeners/CopilotCommandResponse";
import CopilotTranslateMessageResponse
    from "~/operatorApplication/ts/service/comet/listeners/CopilotTranslateMessageResponse";
import OperatorApplicationWebRtcCall from "~/operatorApplication/ts/service/webRtc/OperatorApplicationWebRtcCall";
import initializeWebRtc from "~/ts/library/webRtc/InitializeWebRtc";
import TranscribeAudioFile from "~/operatorApplication/ts/service/comet/listeners/TranscribeAudioFile";
import ResetAutoTemplates from "~/operatorApplication/ts/service/comet/listeners/ResetAutoTemplates";
import NewMessageState from "~/operatorApplication/ts/service/comet/listeners/NewMessageState";

let instance: Listener;

function operatorCometListenerDestroy() {
    if (instance) {
        instance.destroy();
        instance = null;
    }
}

export default function operatorCometListenerInit(currentCometTime: number) {
    OperatorAccountStore.setCometConnected(false);
    instance = OperatorCometListener.create();
    (window as any).OperatorCometListenerInstance = instance;

    initializeWebRtc(
        OperatorApplicationWebRtcCall,
        instance
    );

    instance
        .listenAction(new OperatorStatusChangedInAnotherApp())
        .listenAction(new AddClientToBuddyList())
        .listenAction(new RemoveClientFromBuddyList())
        .listenAction(new UpdateClient())
        .listenAction(new UpdateUnreadedMessageIdList())
        .listenAction(new UpdateOperatorDialogCount())
        .listenAction(new UpdateParams())
        .listenAction(new OperatorsOnlineUpdatedListener())
        .listenAction(new NewMessage())
        .listenAction(new EditMessage())
        .listenAction(new DeleteMessage())
        .listenAction(new NewMessageState())
        .listenAction(new Ping())
        .listenAction(new ResetAutoTemplates())
        .listenAction(new MessageTemplatesUpdated())
        .listenAction(new ChangeMessageStatus())
        .listenAction(new CheckToken())
        .listenAction(new SnippetListener())
        .listenAction(new Typing())
        .listenAction(new OperatorTyping())
        .listenAction(new ClientClickOnLink())
        .listenAction(new NewTargetClient())
        .listenAction(new MessageDialogUpdated())
        .listenAction(new CopilotCommandResponse())
        .listenAction(new CopilotTranslateMessageResponse())
        .listenAction(new TranscribeAudioFile());


    instance.onPreviousTimestampMismatch(async (payload: CometTimestampMismatchPayloadInterface) => {
        try {
            await Delay.make(100, OPERATOR_APPLICATION_RELOAD_DATA_EVENT, true);
            console.warn("Не совпали timestamp-ы в comet, перезагружаем параметры", payload);
            OperatorApplicationEventManager.emit(OPERATOR_APPLICATION_RELOAD_DATA_EVENT, JSON.stringify({
                cometTimestampMismatch: true,
                payload
            }));
        } catch (e) {

        }
    });

    let error = false;

    instance.onError(() => {
        error = true;
        OperatorAccountStore.setCometConnected(false);
    });

    instance.onConnected(() => {
        if (error) {
            error = false;
        }
        OperatorAccountStore.setCometConnected(true);
    });

    OperatorCometListener.start(currentCometTime);

    return instance;
}

OperatorApplicationEventManager.addEventListener(OPERATOR_LOGGED_OUT, () => {
    operatorCometListenerDestroy();
});